import styles from './FJMobileCreationView.module.less';
import PropTypes from 'prop-types';
import FJMobileImageItem from '../../FJMainPreview/FJMobileImageItem/FJMobileImageItem';
import { useEffect, useRef, useState } from 'react';
const PADDING = 16;

const FJMobileCreationView = props => {
    const { creationList = [], previewImage, reGenerate, style } = props;
    const containerRef = useRef();
    const [imgRect, setImgRect] = useState({});

    useEffect(() => {
        if (!creationList?.length) return;
        const item = creationList[0];
        const { width, height } = item;
        const ratio = width / height;
        let w = 300;
        if (containerRef.current) {
            w = containerRef.current.offsetWidth - PADDING * 2;
            if (ratio <= 1 && creationList.length > 1) {
                w = (containerRef.current.offsetWidth - PADDING * 2 - 6) / 2;
            }
        }
        let h = w / ratio;
        setImgRect({ w, h });
    }, [creationList]);
    // 没有内容不展示
    if (creationList?.length === 0) return null;
    return (
        <div className={styles.inner} ref={containerRef} style={style}>
            {creationList.map(item => (
                <div key={item.id} className={styles.creation_item} style={{ width: imgRect.w, height: imgRect.h }}>
                    <FJMobileImageItem item={item} onPreview={previewImage} reGenerate={reGenerate} />
                </div>
            ))}
        </div>
    );
};
FJMobileCreationView.propTypes = {
    creationList: PropTypes.array,
    previewImage: PropTypes.func,
    reGenerate: PropTypes.func,
    style: PropTypes.object,
};
export default FJMobileCreationView;
